exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3y9jZhD6A4E-V0AalmnZUv{\n    height: 50px;\n    width: 100%;\n    background-color: #2968A5;\n    position: fixed;\n    top: 0;\n    z-index: 999;\n}\n._3y9jZhD6A4E-V0AalmnZUv h1, ._3y9jZhD6A4E-V0AalmnZUv h2{\n    display: inline-block;\n    margin: 0;\n    color: white;\n    font-weight: 200;\n    font-size: 30px;\n}\n._3y9jZhD6A4E-V0AalmnZUv h2{\n    margin-left: 5px;\n    font-size: 12px;\n    color: #f4f4f4;\n    position: absolute;\n    margin-top: 15px;\n}\n._3y9jZhD6A4E-V0AalmnZUv img{\n    height: 30px;\n    vertical-align: top;\n    display: inline-block;\n}\n._3y9jZhD6A4E-V0AalmnZUv .j0TlMAXVo1lZi5JLDZVYN{\n    padding-top: 10px;\n}\n\n@media print{\n    ._3y9jZhD6A4E-V0AalmnZUv{\n        display: none;\n    }\n}\n\n/* Needed solely for react-styleable */\n.LovoPR2SZTZJ8ct_TsLbQ {}\n", ""]);

// exports
exports.locals = {
	"webctopbar": "_3y9jZhD6A4E-V0AalmnZUv",
	"content": "j0TlMAXVo1lZi5JLDZVYN",
	"languagechoice": "LovoPR2SZTZJ8ct_TsLbQ"
};